module.exports = __webpack_public_path__ + "img/totes.d8674e54.svg";